import './PatientAdd.scss';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Skeleton,
  Space,
  Upload,
} from 'antd';
import Heading from '../../common/Heading/Heading';
import { useSelector } from 'react-redux';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  addPatient,
  getCountries,
  getCountriesWithLanguages,
  getLanguages,
  getPatientDetails,
  updatePatient,
} from '../../../network/patients';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingForm } from '../../../Loading/Loading';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import PhoneInputWithCountrySelect, {
  parsePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input';
import { bloodGroups } from '../../../utils/constants';
import { useState } from 'react';
import { getIllnesses } from '../../../network/illnesses';
import { FaCalendarCheck } from 'react-icons/fa';
import {DownOutlined} from '@ant-design/icons';
const PatientAdd = ({ t, edit }) => {
  const { id } = useParams();
  const client = useQueryClient();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { currentLang } = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const { mutate: onAddPatient } = useMutation({
    mutationKey: ['addPatient'],
    mutationFn: (body) => (edit ? updatePatient(id,body) : addPatient(body)),
    onSuccess: (data) => {
      setLoadingAdd(false);
      // console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      // edit
      //   ? message.success('Patient edited successfully')
      //   : message.success('Patient added successfully');
      message.success(data?.message?.message);
      client.invalidateQueries({ queryKey: [queryKeys.getPatients] });
      form.resetFields();
      navigate('/patients');
    },
    onError: (error) => {
      setLoadingAdd(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      // console.log('error:', error);
      // message.error(error);
    },
  });

  const onFinish = (values) => {
    console.log('Finish:', values);
    setLoadingAdd(true);
      onAddPatient({
          ...values,
          dob: values.dob.format('YYYY-MM-DD'),
          image: '',
          custom_file_number: id,
      });
  };
  const { data: countries } = useQuery({
    queryKey: [queryKeys.countriesWithLanguages, currentLang],
    queryFn: () => getCountriesWithLanguages(currentLang),
    keepPreviousData: true,
  });
  const { data: languages } = useQuery({
    queryKey: [queryKeys.languages],
    queryFn: () => getLanguages(),
    keepPreviousData: true,
  });
  const { data: illnesses } = useQuery({
    queryKey: [queryKeys.getIllnesses, currentLang],
    queryFn: () => getIllnesses(currentLang),
    keepPreviousData: true,
  });
  const { data: patientData, isLoading } = useQuery({
    queryKey: [queryKeys.patientDetails, id],
    queryFn: () => getPatientDetails(id),
    enabled: !!edit,
  });
  if (isLoading) {
    return <LoadingForm />;
  }
  // console.log('isLoading:', isLoading);

  const disabledDate = (current) => {
    return current && current > dayjs().startOf('day');
  };
  const itemsMenu = [
    {
      key: '1',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<FaCalendarCheck />}
          // disabled={
          //   purchaseOrderDetails?.data?.status === 'Draft' ? false : true
          // }
        >
          {t.addAnAppointment}
        </Button>
      ),
      onClick:() =>{
        navigate(
          `/appointments/patient/add/${id}`
        )
      }
    },
  ];
  return (
    <div className="patient-add">
      <Heading title={t.patient} subTitle={ edit ? t.editPatient : t.addPatient} path="/patients" />
      
      <Card>
      <Flex  align="center" justify="space-between"
       style={
        {
          marginBottom: '20px'
        }
       }
      >
      <h4 className="">{t.titleCardAddPatient}</h4>
          {edit && (
            <Dropdown
              menu={{ items: itemsMenu }}
              trigger={['click']}
              arrow
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text" className="btn-light">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit
              ? {
                  ...patientData?.data,
                  illnesses: patientData?.data?.custom_ill?.map(
                    (x) => +x?.ill
                  ),
                  dob: dayjs(patientData?.data?.dob),
                }
              : {}
          }
        >
          <Divider orientation="left">{t.patientInformation}</Divider>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                // name="firstName"
                name="first_name"
                label={t.firstName}
                rules={[
                  {
                    required: true,
                    message: t.requiredFirstName,
                  },
                ]}
              >
                <Input placeholder={t.firstName} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="middle_name"
                // name="middleName"
                label={t.middleName}
                rules={[
                  {
                    required: true,
                    message: t.requiredMiddleName,
                  },
                ]}
              >
                <Input placeholder={t.middleName} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="last_name"
                label={t.lastName}
                rules={[
                  {
                    required: true,
                    message: t.requiredLastName,
                  },
                ]}
              >
                <Input placeholder={t.lastName} />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="age"
                label={t.age}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.age} type='number' />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="sex"
                label={t.gender}
                rules={[
                  {
                    required: true,
                    message: t.requiredGender,
                  },
                ]}
              >
                <Select
                  placeholder={t.gender}
                  options={[
                    {
                      value: 'Male',
                      label: t.male,
                    },
                    {
                      value: 'Female',
                      label: t.female,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                rules={[
                  {
                    required: true,
                  },
                ]}
                name="dob"
                label={t.DateOfBirth}
              >
                <DatePicker
                  placeholder={t.DateOfBirth}
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="uid"
                label={t.identificationNumber}
                rules={[
                  {
                    required: true,
                    message: t.requireIdentificationNumber,
                  },
                  {
                    len: 10,
                  },
                ]}
              >
                <Input type="number" placeholder={t.identificationNumber} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="blood_group" label={t.bloodGroup}>
                <Select placeholder={t.bloodGroup}>
                  {bloodGroups.map((bloodGroup) => (
                    <Select.Option
                      key={bloodGroup.value}
                      value={bloodGroup.value}
                    >
                      {currentLang === 'en'
                        ? bloodGroup.english
                        : bloodGroup.arabic}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="mobile"
                label={t.mobile}
                className="w-full"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: (rule, value) => {
                      console.log(value, 'value');
                      if (isValidPhoneNumber(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject('رقم الجوال غير صالح');
                    },
                  },
                ]}
                hasFeedback
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  className="w-full"
                  name="phone"
                  label={t.mobile}
                  international
                  hasFeedback
                  limitMaxLength={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                // name="phone"
                label={t.phoneNumber}
                className="w-full"
                // required={false}
                // hasFeedback
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  className="w-full"
                  name="phone"
                  label={t.phoneNumber}
                  international
                  // hasFeedback
                  // limitMaxLength={true}
                />
              </Form.Item>

              {/* <Form.Item
                name="phone"
                label={t.phoneNumber}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredPhoneNumber,
                //   },
                // ]}
              >
                <Input type="number" placeholder={t.phoneNumber} />
              </Form.Item> */}
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="email"
                label={t.email}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredEmail,
                //   },
                // ]}
              >
                <Input type="email" placeholder={t.email} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="occupation"
                label={t.occupation}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredOccupation,
                //   },
                // ]}
              >
                <Input placeholder={t.occupation} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="marital_status"
                label={t.maritalStatus}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requireMaritalStatus,
                //   },
                // ]}
              >
                <Select
                  placeholder={t.maritalStatus}
                  options={[
                    {
                      value: 'Single',
                      label: t.single,
                    },
                    {
                      value: 'Married',
                      label: t.married,
                    },
                    {
                      value: 'Divorced',
                      label: t.divorced,
                    },
                    {
                      value: 'Widow',
                      label: t.widow,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="custom_country"
                // name="territory"
                label={t.Country}
                rules={[
                  {
                    required: true,
                    message: t.requireCountry,
                  },
                ]}
              >
                <Select
                  placeholder={t.Country}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  options={countries?.message?.countries?.map((country) => ({
                    value: country.name,
                    label: currentLang === 'en' ? country.en : country.ar,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="report_preference"
                label={t.reports}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredReports,
                //   },
                // ]}
              >
                <Select
                  placeholder={t.reports}
                  options={[
                    {
                      value: 'Email',
                      label: t.email,
                    },
                    {
                      value: 'Print',
                      label: t.Print,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="language" label={t.printLanguage}>
                <Select
                  placeholder={t.printLanguage}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  options={languages?.message?.languages?.map((language) => ({
                    value: language.name,
                    label: language.language_name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="custom_dating_methods"
                label={
                  currentLang === 'en'
                    ? 'How did you know about us'
                    : 'كيف عرفت عنا'
                }
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={
                    currentLang === 'en'
                      ? 'How did you know about us'
                      : 'كيف عرفت عنا'
                  }
                >
                  {/* <Select.Option value="Email">Email</Select.Option> */}
                  <Select.Option value="Visiting the center">
                    {currentLang === 'en'
                      ? 'Visiting the center'
                      : 'زيارة المركز'}
                  </Select.Option>
                  <Select.Option value="Google ads">
                    {currentLang === 'en' ? 'Google ads' : 'إعلانات جوجل'}
                  </Select.Option>
                  <Select.Option value="Snapchat ads">
                    {currentLang === 'en' ? 'Snapchat ads' : 'إعلانات سناب شات'}
                  </Select.Option>
                  <Select.Option value="Instagram ads">
                    {currentLang === 'en'
                      ? 'Instagram ads'
                      : 'إعلانات إنستجرام'}
                  </Select.Option>
                  <Select.Option value="Other social media platforms">
                    {currentLang === 'en'
                      ? 'Other social media platforms'
                      : 'منصات التواصل الاجتماعي الأخرى'}
                  </Select.Option>
                  <Select.Option value="Online store or website">
                    {currentLang === 'en'
                      ? 'Online store or website'
                      : 'المتجر الإلكتروني أو الموقع الإلكتروني'}
                  </Select.Option>
                  <Select.Option value="Application offers">
                    {currentLang === 'en'
                      ? 'Application offers'
                      : 'عروض التطبيقات'}
                  </Select.Option>
                  <Select.Option value="WhatsApp messages">
                    {currentLang === 'en'
                      ? 'WhatsApp messages'
                      : 'رسائل واتساب'}
                  </Select.Option>
                  <Select.Option value="One of the center’s employees">
                    {currentLang === 'en'
                      ? 'One of the center’s employees'
                      : 'أحد موظفي المركز'}
                  </Select.Option>
                  <Select.Option value="A friend">
                    {currentLang === 'en' ? 'A friend' : 'صديق'}
                  </Select.Option>
                  <Select.Option value="Celebrities and bloggers">
                    {currentLang === 'en'
                      ? 'Celebrities and bloggers'
                      : 'المشاهير والمدونين'}
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>

            {/* <Divider orientation="left"> {t.financialDetails} </Divider>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="default_currency"
                label={
                  currentLang === 'en' ? 'Billing Currency' : 'عملة الفواتير'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please select !'
                //         : 'الرجاء اختيار ',
                //   },
                // ]}
              >
                <Select
                  placeholder={
                    currentLang === 'en' ? 'Billing Currency' : 'عملة الفواتير'
                  }
                >
                  <Select.Option value="SAR">
                    {' '}
                    {currentLang === 'en' ? 'SAR' : 'السعودية'}{' '}
                  </Select.Option>
                  <Select.Option value="USD">
                    {' '}
                    {currentLang === 'en' ? 'USD' : 'الدولار'}{' '}
                  </Select.Option>
                  <Select.Option value="EUR">
                    {' '}
                    {currentLang === 'en' ? 'EUR' : 'اليورو'}{' '}
                  </Select.Option>
                  <Select.Option value="GBP">
                    {' '}
                    {currentLang === 'en' ? 'GBP' : 'الجنيه'}{' '}
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="default_price_list"
                label={
                  currentLang === 'en' ? 'Default Price' : 'السعر الافتراضي'
                }
                rules={[
                  {
                    required: true,
                    message:
                      currentLang === 'en'
                        ? 'Please input your default price!'
                        : 'الرجاء ادخال سعر الافتراضي',
                  },
                ]}
              >
                <Select
                  placeholder={
                    currentLang === 'en' ? 'Default Price' : 'السعر الافتراضي'
                  }
                >
                  <Select.Option value="Standard Selling">
                    {currentLang === 'en' ? 'Standard Selling' : 'بيع عادي'}
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col> */}
          </Row>
          <Divider orientation="left">{t.patientHistory}</Divider>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Form.Item name="illnesses" label={t.illnesses}>
                <Select
                  placeholder={t.illnesses}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  allowClear
                  mode="multiple"
                  options={illnesses?.data?.map((country) => ({
                    value: country.name,
                    label: country?.[currentLang === 'en' ? 'en' : 'ar'],
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="medication"
                label={
                  currentLang === 'en' ? 'Medication' : 'العمليات السابقه '
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your medication!'
                //         : 'الرجاء ادخال الاجراءات الطبية',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en' ? 'Medication' : 'العمليات السابقه '
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="medical_history"
                label={t.medialHistory}
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your medication history!'
                //         : 'الرجاء ادخال تاريخ الاجراءات الطبية',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={t.medialHistory}
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="medical_history"
                label={
                  currentLang === 'en'
                    ? 'Medication History'
                    : 'تاريخ الاجراءات الطبية'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your medication history!'
                //         : 'الرجاء ادخال تاريخ الاجراءات الطبية',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en'
                      ? 'Medication History'
                      : 'تاريخ الاجراءات الطبية'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="patient_details"
                label={
                  currentLang === 'en' ? 'Patient Details' : 'تفاصيل المريض'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your patient details!'
                //         : 'الرجاء ادخال تفاصيل المريض',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en' ? 'Patient Details' : 'تفاصيل المريض'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="allergies"
                label={currentLang === 'en' ? 'Allergies' : 'الحساسية'}
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your allergies!'
                //         : 'الرجاء ادخال الحالات الجنسية',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en'
                      ? 'Tobacco Consumption (Past)'
                      : 'استهلاك التبغ (السابق)'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="tobacco_past_use"
                label={
                  currentLang === 'en'
                    ? 'Tobacco Consumption (Past)'
                    : 'تعامل الكحول (منذ المرض)'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your tobacco consumption!'
                //         : 'الرجاء ادخال تعامل الكحول',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en'
                      ? 'Tobacco Consumption (Past)'
                      : 'تعامل الكحول (منذ المرض)'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="tobacco_current_use"
                label={
                  currentLang === 'en'
                    ? 'Tobacco Consumption (Present)'
                    : 'استهلاك التبغ (الحالي)'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your alcohol consumption!'
                //         : 'الرجاء ادخال تعامل الكحول',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en'
                      ? 'Alcohol Consumption (Past)'
                      : 'تعامل الكحول (منذ المرض)'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="alcohol_past_use"
                label={
                  currentLang === 'en'
                    ? 'Alcohol Consumption (Past)'
                    : 'استهلاك الكحول (السابق)'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your alcohol consumption!'
                //         : 'الرجاء ادخال تعامل الكحول',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en'
                      ? 'Alcohol Consumption (Past)'
                      : 'استهلاك الكحول (السابق)'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="surrounding_factors"
                label={
                  currentLang === 'en'
                    ? 'Occupational Hazards and Environmental Factors'
                    : 'المخاطر المهنية والعوامل البيئية'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your occupational hazards and environmental factors!'
                //         : 'الرجاء ادخال المخاطر التجارية والعوائل البيئية',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en'
                      ? 'Occupational Hazards and Environmental Factors'
                      : 'المخاطر المهنية والعوامل البيئية'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="other_risk_factors"
                label={
                  currentLang === 'en'
                    ? 'Other Risk Factors'
                    : 'عوامل الخطر الأخرى'
                }
                // rules={[
                //   {
                //     required: true,
                //     message:
                //       currentLang === 'en'
                //         ? 'Please input your other risk factors!'
                //         : 'الرجاء ادخال المخاطر الاخرى',
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={
                    currentLang === 'en'
                      ? 'Other Risk Factors'
                      : 'عوامل الخطر الأخرى'
                  }
                  autoSize={{ minRows: 4, maxRows: 5 }}
                />
              </Form.Item>
            </Col> */}
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default PatientAdd;
